import React, { useState } from 'react';
import className from 'classnames';
import axios from 'axios';
import Waypoint from 'react-waypoint';

import Loading from '../Loading';
import TableHeader from '../TableHeader';

const PostScores = ({
  postId
}) => {
  const [postScores, setPostScores] = useState([])
  const [shouldFetch, setShouldFetch] = useState(true)

  const _fetchData = () => {
    if (shouldFetch) {
      fetchPostScores()
    }
  }

  const fetchPostScores = () => {
    axios.get(`/${gon.currentProvider}/api/post_scores`, {
      params: {
        post_ids: [postId]
      }
    })
      .then((res) => {
        if (res.status == 200) {
          setShouldFetch(false)
          setPostScores(res.data)
        }
      })
  }


  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h3 className='MainHeader__h3'>Post Scores</h3>
        </div>
      </div>
      <Waypoint onEnter={_fetchData}>
        <div
          className={className('Table', {
            'Table--post-scores': true,
          })} style={{gridTemplateColumns: '0.5fr 2fr'}}
        >
          {(() => {
          const columnHeaders = [
            {
              label: 'Score'
            },
            {
              label: 'Breakdown'
            }
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <TableHeader
                  key={key}
                  header={header}
                />
              ))}
            </div>
            )
          })()}
          <Loading isLoading={shouldFetch}>
            {
              postScores.length < 1 &&
                <div className='Table__row__no-records'>No records</div>
            }
            {postScores.map((postScore) => (
              <div
                className='Table__row'
                key={postId}
              >
                <div className='Table__col'>{(+postScore.score).toLocaleString()}</div>
                <div className='Table__col'>
                  <table>
                    <tbody>
                      {
                        Object.entries(postScore.breakdown).map(([key, value]) => {
                          return <tr key={`${postScore.id}-breakdown-${key}`}><td>{key}: {value}</td></tr>
                        })
                      }
                  </tbody>
                  </table>
                </div>
              </div>
            ))}
          </Loading>
        </div>
      </Waypoint>
    </React.Fragment>
  )
}

export default PostScores
